import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import deleteIcon from "assets/img/deleteicon.png";
import viewIcon from "assets/img/Viewicon.png";
import "./Note.css";
import { Link } from "react-router-dom";

let timer = 500,
  timeout;

function Note(props) {
  const [title, setTitle] = useState(props.note.title);
  const [text, setText] = useState(props.note.text);

  const debounce = (func) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, timer);
  };

  const updateText = (newTitle, newText) => {
    debounce(() => props.updateText(newTitle, newText, props.note.stickyNotesId, props.note.color));
  };

  const formatupdateDate = (dateString) => {
    const date = new Date(dateString);

    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    };
    return date.toLocaleString('en-IN', options);
  };

  return (
    <div className="note" style={{ backgroundColor: props.note.color }}>
      <input
        type="text"
        className="note_title"
        maxLength={40}
        id="title"
        name="title"
        value={title}
        onChange={(event) => {
          setTitle(event.target.value);
          updateText(event.target.value, text); // Passing updated title and current text
        }}
        style={{ boxShadow: 'none' }}
        placeholder="Title here...."
      />
      <ReactQuill
        className="note_text"
        value={text} // Changed from defaultValue to value
        onChange={(newText) => {
          setText(newText);
          updateText(title, newText); // Passing current title and updated text
        }}
        placeholder="Text here......"
        modules={{
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['link', 'image', 'video'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
          ]
        }}
        style={{ overflowY: 'auto' }}
      />
      <div className="flex justify-between mt-2">
        <p><b>{formatupdateDate(props.note.lastUpdatedDate)}</b></p>
        <div>
          <Link to={`/notes/${props.note.stickyNotesId}`}>
            <img
              src={viewIcon}
              style={{ height: '20px', marginRight: '10px', marginLeft: '5px' }}
              alt="VIEW"
              title="VIEW"
            />
          </Link>
          <img
            src={deleteIcon}
            style={{ height: '20px', marginTop: '2px' }}
            alt="DELETE"
            title="DELETE"
            onClick={() => props.deleteNote(props.note.stickyNotesId)}
          />
        </div>
      </div>
    </div>
  );
}

export default Note;
